export const name = "SAFE_CONVERT_BYTES_TO_STRING";
export const summary = `Converts a \`BYTES\` value to a \`STRING\` value and replace any invalid UTF-8 characters with the Unicode replacement character, \`U+FFFD\`.`;
export const reference = `
## SAFE_CONVERT_BYTES_TO_STRING

Converts a \`BYTES\` value to a \`STRING\` value and replace any invalid UTF-8 characters with the Unicode replacement character, \`U+FFFD\`.

\`\`\`
SAFE_CONVERT_BYTES_TO_STRING(value)
\`\`\`

### Description

Converts a sequence of \`BYTES\` to a \`STRING\`. Any invalid UTF-8 characters are replaced with the Unicode replacement character, \`U+FFFD\`.


### Return type

\`STRING\`


### Examples

The following statement returns the Unicode replacement character, �.



\`\`\`
SELECT SAFE_CONVERT_BYTES_TO_STRING(b'\\xc2') as safe_convert;
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
